import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Button, Icon } from '@folio/stripes/components';

const ActionMenuOpenTransactionsButton = ({
  handleOpenTransactionsReportClick,
  onToggle,
}) => {
  return (
    <Button
      buttonStyle="dropdownItem"
      id="export-open-transactions-report"
      onClick={() => {
        onToggle();
        handleOpenTransactionsReportClick();
      }}
    >
      <Icon icon="download">
        <FormattedMessage id="ui-users.openTransactions.report.button" />
      </Icon>
    </Button>
  );
};

ActionMenuOpenTransactionsButton.propTypes = {
  handleOpenTransactionsReportClick: PropTypes.func.isRequired,
  onToggle: PropTypes.func.isRequired,
};

export default ActionMenuOpenTransactionsButton;
